import actionTypes from 'SRC/modules/redux/actionTypes'

export const setShowNavigation = showNavigation => ({
  type: actionTypes.SET_VEHICLE_PARTS_SHOW_NAVIGATION,
  payload: showNavigation
})
